import parseAPNG, { APNG } from 'apng-js'
import { RefObject, useEffect, useRef, useState } from 'react'

import { captureError } from '@/core/errors'
/**
 * @deprecated remove when animation type changed to video
 */
export function useApngAnimation({ url }: { url: string }) {
  const [apng, setApng] = useState<APNG | null>(null)
  const [playing, setPlaying] = useState(false)
  const [error, setError] = useState(null)
  const ref = useRef<HTMLCanvasElement>(null)

  /**
   * アニメーション画像(apng)を取得
   */
  useEffect(() => {
    if (!url) return

    setError(null)
    generateApng(url)
      .then(apng => setApng(apng))
      .catch(e => {
        captureError(e, 'useApngAnimationGenerateApng')
        setError(e)
      })
  }, [url])

  const play = async () => {
    if (!apng) throw new Error('the apng file cannot be played.')

    await setPlaying(true)
    return (
      playApngAnimation(ref, apng)
        .then(result => {
          setPlaying(false)
          return result
        })
        // エラーが出た場合、プレイヤーの停止
        .catch(e => {
          captureError(e, 'useApngAnimationPlayAnimation')
          setError(e)
          setPlaying(false)
        })
    )
  }

  return {
    error,
    playing,
    play,
    ref,
  }
}

/**
 * アニメーションの再生
 *
 * @deprecated remove when animation type changed to video
 *
 * @param ref
 * @param apng
 * @returns player
 */
export async function playApngAnimation(
  ref: RefObject<HTMLCanvasElement>,
  apng: APNG
) {
  if (!ref?.current) return

  const ctx = ref.current.getContext('2d')

  if (!ctx) return

  return new Promise((res, rej) => {
    apng.getPlayer(ctx).then(player => {
      player.removeAllListeners('end')
      // stop and rewind at the beginning on every time
      player.stop()
      player.on('end', () => {
        res(player)
      })
      player.play()
    })
  })
}

/**
 * Apngオブジェクトの生成
 *
 * @deprecated remove when animation type changed to video
 * @param url
 * @returns
 */
export function generateApng(url: string) {
  return fetch(url)
    .then(res => res.arrayBuffer())
    .then(buffer => {
      const parseResult = parseAPNG(buffer)
      if (parseResult instanceof Error) throw parseResult

      return parseResult
    })
}
